<app-preloader></app-preloader>
<div class="h-100" [class]="platformClass">
  <!-- WCAG 1.3.1 — single <main> per page comes from routed layouts (main-layout, preview-layout); outer shell stays a generic wrapper. -->
  <div class="app-wrapper" [class]="simulateClass">
    <app-simulate-bar (simulateClassChange)="onSimulateClassChange($event)"> </app-simulate-bar>
    <app-message-alert> </app-message-alert>
    <app-notifications-broadcast></app-notifications-broadcast>
    <router-outlet></router-outlet>
  </div>
</div>
